import { createAction } from '@ngrx/store';

export const OpenMenu = createAction('[Nav] Open menu');
export const CloseMenu = createAction('[Nav] Close menu');
export const ToggleMenu = createAction('[Nav] Toggle menu');

export const EnableFunnel = createAction('[Nav] Enable funnel menu');
export const DisableFunnel = createAction('[Nav] Disable funnel menu');
